const set = (attributes, vals, defaultVal) =>
  Object.keys(attributes).reduce((aggregate, key) => {
    let val = attributes[key];
    if (!val) {
      return aggregate;
    }
    if (typeof val === 'string') {
      val = vals[val] || val;
    } else {
      val = defaultVal;
    }
    return `${aggregate}${key}:${val};`;
  }, '');

const padding = props => {
  const {
    theme: { padding: vals },
    padding: val,
    paddingVertical = val,
    paddingHorizontal = val,
    paddingTop = paddingVertical,
    paddingBottom = paddingVertical,
    paddingLeft = paddingHorizontal,
    paddingRight = paddingHorizontal,
  } = props;

  return set(
    {
      'padding-top': paddingTop,
      'padding-bottom': paddingBottom,
      'padding-left': paddingLeft,
      'padding-right': paddingRight,
    },
    vals,
    vals.normal
  );
};

const margin = props => {
  const {
    theme: { margin: vals },
    margin: val,
    marginVertical = val,
    marginHorizontal = val,
    marginTop = marginVertical,
    marginBottom = marginVertical,
    marginLeft = marginHorizontal,
    marginRight = marginHorizontal,
  } = props;

  return set(
    {
      'margin-top': marginTop,
      'margin-bottom': marginBottom,
      'margin-left': marginLeft,
      'margin-right': marginRight,
    },
    vals,
    vals.normal
  );
};

const flex = props => {
  const {
    flexBox = false,
    flexDirection = 'row',
    alignItems = flexDirection === 'row' ? 'center' : 'stretch',
    alignContent = 'flex-start',
    justifyContent = 'flex-start',
    flexWrap = 'nowrap',
    flex: flexVal = '0 1 auto',
  } = props;

  if (!flexBox) {
    return '';
  }

  return `
    display: flex;
    flex-direction: ${flexDirection};
    align-items: ${alignItems};
    align-content: ${alignContent};
    justify-content: ${justifyContent};
    flex-wrap: ${flexWrap};
    flex: ${flexVal};
  `;
};

const show = props => {
  const { show: showVal = true } = props;

  return !showVal ? 'display:none;' : '';
};

const align = props => {
  const { align: textAlign } = props;

  if (!textAlign) {
    return '';
  }

  return `
    display: block;
    text-align: ${textAlign};
  `;
};

export { padding, margin, flex, show, align };
